import React from "react";
import { useFormatter } from "../../util/formatter";

function OnPeakOffPeakInfo(props) {
  const [formatNumber] = useFormatter();
  return (
    <>
      {" ( " + props.peakLabel[0] + ": "}
      <span id="gridOn">{formatNumber(props.data.ON, 0)}</span> kWh
      {" |"}
      {" " + props.peakLabel[1] + ": "}
      <span id="gridOff">{formatNumber(props.data.OFF, 0)}</span> kWh )
    </>
  );
}

export default OnPeakOffPeakInfo;
